import { render, staticRenderFns } from "./CTC.vue?vue&type=template&id=198e3220&scoped=true"
import script from "./CTC.vue?vue&type=script&lang=js"
export * from "./CTC.vue?vue&type=script&lang=js"
import style0 from "./CTC.vue?vue&type=style&index=0&id=198e3220&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198e3220",
  null
  
)

export default component.exports